
export const eventBlock = {
  FRESH_RESULT: 'FRESH_RESULT'
}
export const eventApproval = {
  FRESH_MY_APPROVAL_LIST: 'FRESH_MY_APPROVAL_LIST'
}